import { MessageTemplate } from "../api/types/messages"
import { Base64 } from 'js-base64';

const weeklyBoiler = [
    '<p>Bonjour,</p>',
    '<p style="text-align: justify; text-justify: inter-word;">Nous vous invitons à remplir votre questionnaire hebdomadaire, que vous soyez malade ou non, en cliquant sur le lien suivant :</p>',
    '<p style="text-align:center">{=weekly_button=}</p>',
    '<p style="font-size: .9em">Ce message est envoyé automatiquement car votre compte est configuré pour recevoir les rappels hebdomadaires. Si vous ne souhaitez pas recevoir ce rappel, rendez-vous sur votre espace et décochez l\'option "Oui, je souhaite recevoir l\'e-mail de rappel hebdomadaire".</p>'
];

interface MessageBoilerplate {
    label: string;
    template: MessageTemplate
}

export const useMessageBoilerplates = (collection: string): MessageBoilerplate[] => {
    
    const boilerplates:MessageBoilerplate[] = [
        {  
            label: 'Weekly newsletter',
            template: {
                messageType: 'weekly',
                defaultLanguage: 'fr',
                translations: [
                    {
                        'lang':'fr',
                        'subject':'[Grippenet] Newsletter',
                        'templateDef': Base64.encode(weeklyBoiler.join("\n"))
                    },
                ]
            }
        }
    ];

    return boilerplates;
}